/** Centralized backend endpoint paths (relative to BASE_URL). */
export const ApiEndPoints = {
  // Auth
  access: {
    login: 'access/login',
    me: 'access/me',
  },

  // Roles & permissions
  role: 'access/role',
  permission: 'access/permission',
  rolePermission: 'access/role-permission',

  // Users
  users: 'access/users',
  usersImportTemplate: 'access/users/import-template',
  usersImport: 'access/users/import',
  organizationNode: 'organisation/node',

  // Engagements (user flow)
  engagement: 'engagement',
  usersInArea: 'organisation/users-in-area',

  // Tasks & subtasks (nested under an engagement)
  task: 'task',

  // File upload (backend proxies to S3 and returns the stored URL)
  uploadS3: 'upload/s3',

  // Organizations
  organization: 'organisation/organization',
  organizationEcScope: 'organisation/organization-ec-scope',
  organizationEcScopeBulk: 'organisation/organization-ec-scope/bulk',
  organizationLevel: 'organisation/level',
  organizationLevelBulk: 'organisation/level/bulk',
  organizationHierarchyTemplate: 'organisation/hierarchy/template',
  organizationHierarchyUpload: 'organisation/hierarchy/upload',
  organizationNodeTree: 'organisation/node/tree',
  organizationNodeArea: 'organisation/node-area',

  // Territory (location hierarchy — loaded lazily, level by level)
  territory: {
    ecLevel: 'territory/ec-level',
    state: 'territory/state',
    parliament: 'territory/parliament',
    assembly: 'territory/assembly',
    booth: 'territory/booth',
    gramPanchayat: 'territory/gram-panchayat',
    village: 'territory/village',
    psVillageMap: 'territory/ps-village-map',
    boothInfo: 'territory/booth-info',
    blockUlb: 'territory/block-ulb',
    ward: 'territory/ward',
  },
} as const;
